React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
_ = require 'underscore'

module.exports = class extends React.Component
  displayName: 'SettingSectionComponent'

  render: t.renderable ->
    { header, contents, onChange, changeContent, changeClasses } = @props

    t.div '.window-module.u-clearfix', ->

      t.div '.window-module-title', ->
        t.h3 '.u-inline', ->
          t.addElement header

      for key in _.keys(contents)
        t.div '.setting-item', ->
          t.div '.setting-item-detail', ->
            t.addElement contents[key]

          t.div '.setting-item-action', ->
            classes =
              'button-link': true
              'u-text-align-center': true
            if changeContent
              t.div className: changeClasses, onClick: onChange, ->
                t.addElement changeContent
            else
              t.b onChange[key], class: t.classify(classes), ->
                t.format 'change'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/setting-multi-section-component.coffee